import React, {useEffect} from 'react';
import {Result} from "antd";
import {useDocumentTitle} from "usehooks-ts";
import {useFavicon} from "../hooks/useFavicon";

export interface INotFoundProps {

}

const NotFoundPage: React.FC<INotFoundProps> = ({}) => {
    return (<>
        <div className={"h-full w-full flex items-center justify-center"}>
            <Result
                status="404"
                title="404"
                subTitle="Aradığınız sayfaya ulaşılamıyor"
            />
        </div>
    </>)
};

export default NotFoundPage;